import { useTranslation } from 'react-i18next'

export const useContextMenuOptions = ({
	handleEdit,
	handleSinglePayoutRequest,
	handleDeleteModalOpen
}: {
	handleEdit: (id: number) => void
	handleSinglePayoutRequest: (id: number) => void
	handleDeleteModalOpen: (id: number) => void
}) => {
	const { t } = useTranslation()

	return [
		{
			label: t('Edit'),
			action: handleEdit
		},
		{
			label: t('Prepare payout'),
			action: handleSinglePayoutRequest
		},
		{
			label: t('Delete'),
			action: handleDeleteModalOpen
		}
	]
}
